module.exports = __webpack_public_path__ + "static/hero-9d7da92ddb039f646b35fa9b8998331b.jpg";